import React, { useState, useEffect } from "react";
import * as ReactBootstrap from "react-bootstrap";
import "../../assets/css/payment.scss";
import Title from "./../../components/ReusableComponents/title";
import caret from "../../assets/images/charm_tick.svg";
import line from "../../assets/images/Line.svg";
import invoice from "../../assets/images/invoice.svg";
import { useSelector, useDispatch } from "react-redux";
import { CalendarComponent } from "@syncfusion/ej2-react-calendars";
import axios from "axios";
import HeadAndDesc from "./../../components/ReusableComponents/HeadAndDesc";
import loggedReducer from "../../store/reducers/isLogged";
import useMobile from "../../hooks/useMobile";
import { dollarUS, formatDate } from "../../utilities/formatters";
import { axiosInstance } from "../../Axios";
import { tokenConfig } from "../../store/reducers/tokenReducer";
import { myStore } from "../..";
import Loader from "../../reusableComponents/Loader";
import { setLoading } from "../../store/reducers/loader";

const StatFormatter = (data) => {
  const Stat = data.toLowerCase();

  const classList = Stat === "succeeded" ? "StatusPassed" : "StatusFailed";

  return <div className={`Status ${classList}`}>{data}</div>;
};

const userNameFormatter = (cell, row) => {
  const dp = row?.dp ? (
    <img src={row.dp} alt={cell} width="30" height="30" />
  ) : (
    <div className="alphabet-cirlce">
      <span>{cell[0].toUpperCase()}</span>
    </div>
  );

  return (
    <div className="column username" style={{ whiteSpace: "nowrap" }}>
      {dp} {cell}
    </div>
  );
};

const PaymentHistory = () => {
  const [DataInfo, setDataInfo] = useState([]);
  // const [width, setWidth] = useState(window.innerWidth);
  const ACCtoken = useSelector((state) => state.ACCtoken);
  const dispatch = useDispatch();
  const loader = useSelector((state)=>state.loader.is_loading)
  const [open,setOpen] = useState(loader)
  useEffect(()=>{
    setOpen(loader)
  },[loader])

  // function handleWindowSizeChange() {
  //   setWidth(window.innerWidth);
  // }
  const isMobile = useMobile();

  useEffect(() => {
    // const data = {
    //   idToken: ACCtoken,
    // };
    dispatch(setLoading(true))
    axiosInstance
      .get("/v2/transaction/history/", tokenConfig(myStore.getState))

      .then((res) => {
        dispatch(setLoading(false))
        
        if (res.data === "No Cases found!") {
          alert("No Cases found!");
          return;
        }
        if (res.data === "Please verify the Access Token!") {
          dispatch(loggedReducer());
          return;
        }
        console.log(res);
        setDataInfo(res.data);
      })
      .catch(function (error) {
        dispatch(setLoading(false))

        console.log(error);
        if (error.response) {
        }
      });
  }, []);

  const [showChall, setshowChall] = useState(false);
  const [showPlan, setshowPlan] = useState(false);
  const [showCalender, setshowshowCalender] = useState(false);
  const [List, setList] = useState([]);
  const [ListAll, setListAll] = useState(true);
  const [ListAllPlan, setListAllPlan] = useState(true);
  const [tickAll, setTickAll] = useState(true);
  const [tick25, setTick25] = useState(false);
  const [tick50, setTick50] = useState(false);
  const [tick100, setTick100] = useState(false);
  const [tick200, setTick200] = useState(false);
  const [ListPlan, setListPlan] = useState([]);
  const [tickPlan, setTickPlan] = useState(true);
  const [tickStandard, setTickStandard] = useState(false);
  const [tickAggressive, setTickAggressive] = useState(false);
  const [tickSwing, setTickSwing] = useState(false);
  const [tickInstant, setTickInstant] = useState(false);

  const ShowCalender = () => {
    setshowshowCalender(!showCalender);
  };

  const handleChangeAll = () => {
    setTickAll(!tickAll);
    setTick25(false);
    setTick50(false);
    setTick100(false);
    setTick200(false);
    setListAll(true);
    setListAllPlan(false);
  };

  const ShowChallenge = () => {
    setshowChall(!showChall);
  };

  const ShowPlan = () => {
    setshowPlan(!showPlan);
  };

  const handleChange25K = (e) => {
    setListAll(false);
    setTickAll(false);
    setTick25(!tick25);
    let varone = "25K Challenge";
    setList((oldArray) => [...oldArray, varone]);
    if (tick25) {
      setList((oldArray) => oldArray.filter((item) => item !== varone));
    }
  };

  const handleChange50K = (e) => {
    setListAll(false);
    setTick50(!tick50);
    let vartwo = "50K Challenge";
    setList((oldArray) => [...oldArray, vartwo]);
    if (tick50) {
      setList((oldArray) => oldArray.filter((item) => item !== vartwo));
    }
  };

  const handleChange100K = (e) => {
    setListAll(false);
    setTick100(!tick100);
    let varthree = "100K Challenge";
    setList((oldArray) => [...oldArray, varthree]);
    if (tick100) {
      setList((oldArray) => oldArray.filter((item) => item !== varthree));
    }
  };

  const handleChange200K = (e) => {
    setListAll(false);
    setTick200(!tick200);
    let varfour = "200K Challenge";
    setList((oldArray) => [...oldArray, varfour]);
    if (tick200) {
      setList((oldArray) => oldArray.filter((item) => item !== varfour));
    }
  };

  const ChallengePopup = () => {
    return (
      <div className="DropChall">
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChangeAll}
        >
          <Title four>All</Title>
          <div>
            <div>{tickAll === true ? <img src={caret} alt="" /> : ""}</div>
          </div>
        </div>
        <img src={line} alt="" />
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChange25K}
        >
          <Title four>25K Challenge</Title>
          <div>
            <div>{tick25 === true ? <img src={caret} alt="" /> : ""}</div>
          </div>
        </div>
        <img src={line} alt="" />
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChange50K}
        >
          <Title four>50K Challenge</Title>
          <div>
            <div>{tick50 === true ? <img src={caret} alt="" /> : ""}</div>
          </div>
        </div>
        <img src={line} alt="" />
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChange100K}
        >
          <Title four>100K Challenge</Title>
          <div>
            <div>{tick100 === true ? <img src={caret} alt="" /> : ""}</div>
          </div>
        </div>
        <img src={line} alt="" />
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChange200K}
        >
          <Title four>200K Challenge</Title>
          <div>
            <div>{tick200 === true ? <img src={caret} alt="" /> : ""}</div>
          </div>
        </div>
      </div>
    );
  };

  const handleChangePlan = () => {
    setTickPlan(!tickPlan);
    setTickStandard(false);
    setTickAggressive(false);
    setTickSwing(false);
    handleChangeInstant(false);
    setListAll(false);
    setListAllPlan(true);
  };

  const handleChangeStandard = (e) => {
    setTickPlan(false);
    setTickStandard(!tickStandard);
    let varone = "Standard Plan";
    setListPlan((oldArray) => [...oldArray, varone]);
    if (tickStandard) {
      setListPlan((oldArray) => oldArray.filter((item) => item !== varone));
    }
  };
  const handleChangeAggressive = (e) => {
    setTickPlan(false);
    setTickAggressive(!tickAggressive);
    let vartwo = "Aggressive Plan";
    setListPlan((oldArray) => [...oldArray, vartwo]);
    if (tickAggressive) {
      setListPlan((oldArray) => oldArray.filter((item) => item !== vartwo));
    }
  };
  const handleChangeSwing = (e) => {
    setTickPlan(false);
    setTickSwing(!tickSwing);
    let varthree = "Swing Plan";
    setListPlan((oldArray) => [...oldArray, varthree]);
    if (tickSwing) {
      setListPlan((oldArray) => oldArray.filter((item) => item !== varthree));
    }
  };
  const handleChangeInstant = (e) => {
    setTickPlan(false);
    setTickInstant(!tickInstant);
    let varfour = "Instant Plan";
    setListPlan((oldArray) => [...oldArray, varfour]);
    if (tickInstant) {
      setListPlan((oldArray) => oldArray.filter((item) => item !== varfour));
    }
  };

  const PlanPopup = () => {
    return (
      <div className="DropChall">
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChangePlan}
        >
          <Title four>All</Title>
          <div>
            <div>{tickPlan === true ? <img src={caret} alt="" /> : ""}</div>
          </div>
        </div>
        <img src={line} alt="" />
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChangeStandard}
        >
          <Title four>Standard Plan</Title>
          <div>
            <div>{tickStandard === true ? <img src={caret} alt="" /> : ""}</div>
          </div>
        </div>
        <img src={line} alt="" />
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChangeAggressive}
        >
          <Title four>Aggressive Plan</Title>
          <div>
            <div>
              {tickAggressive === true ? <img src={caret} alt="" /> : ""}
            </div>
          </div>
        </div>
        <img src={line} alt="" />
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChangeSwing}
        >
          <Title four>Swing Plan</Title>
          <div>
            <div>{tickSwing === true ? <img src={caret} alt="" /> : ""}</div>
          </div>
        </div>
        <img src={line} alt="" />
        <div
          className="DropOpt d-flex justify-content-between"
          onClick={handleChangeInstant}
        >
          <Title four>Instant Funding</Title>
          <div>
            <div>{tickInstant === true ? <img src={caret} alt="" /> : ""}</div>
          </div>
        </div>
      </div>
    );
  };

  const [date, setDate] = useState(new Date());
  const handleChangeCalender = (e) => {
    ListAll(false);
    List(false);
    var doptions = {
      day: "numeric",
      month: "short",
      year: "numeric",
    };
    let var1 = e.target.value.toLocaleDateString("en-GB", doptions);
    setDate(var1);
    alert(var1);
  };

  const TableCalender = () => {
    return (
      <div className="TableCalenderBox">
        {/* <Calendar onChange={handleChangeCalender} value={date}/> */}
        <CalendarComponent
          id="calendar"
          value={date}
          onChange={handleChangeCalender}
        ></CalendarComponent>
      </div>
    );
  };

  return (
    <div className="PageContainer LeaderboardPage PaymentHistoryPage mtt-20" style={{position:"relative"}}>
    <Loader open={open}/>
      {!isMobile ? (
        <div className="HistoryDesk">
          <ReactBootstrap.Table className="LeaderboardTable">
            <thead>
              <tr>
                <th>
                  Funding Evaluation
                  {/* <span style={{ cursor: "pointer" }} onClick={ShowPlan}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.47473 6.22489C7.71881 5.98081 8.11454 5.98081 8.35861 6.22489L11.6919 9.55822C11.936 9.8023 11.936 10.198 11.6919 10.4421L8.35861 13.7754C8.11454 14.0195 7.71881 14.0195 7.47473 13.7754C7.23065 13.5314 7.23065 13.1356 7.47473 12.8916L10.3661 10.0002L7.47473 7.10877C7.23065 6.86469 7.23065 6.46896 7.47473 6.22489Z"
                      fill="#04D9FF"
                    />
                  </svg>
                </span>
                <div className="ShowChallengePopup">
                  {showPlan && <PlanPopup />}
                </div> */}
                </th>
                <th>
                  Account Balance
                  {/* <span style={{ cursor: "pointer" }} onClick={ShowChallenge}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.47473 6.22489C7.71881 5.98081 8.11454 5.98081 8.35861 6.22489L11.6919 9.55822C11.936 9.8023 11.936 10.198 11.6919 10.4421L8.35861 13.7754C8.11454 14.0195 7.71881 14.0195 7.47473 13.7754C7.23065 13.5314 7.23065 13.1356 7.47473 12.8916L10.3661 10.0002L7.47473 7.10877C7.23065 6.86469 7.23065 6.46896 7.47473 6.22489Z"
                      fill="#04D9FF"
                    />
                  </svg>
                </span>
                <div className="ShowChallengePopup">
                  {showChall && <ChallengePopup />}
                </div> */}
                </th>
                <th>Transaction ID</th>
                <th>
                  Date
                  {/* <span style={{ cursor: "pointer" }} onClick={ShowCalender}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.47473 6.22489C7.71881 5.98081 8.11454 5.98081 8.35861 6.22489L11.6919 9.55822C11.936 9.8023 11.936 10.198 11.6919 10.4421L8.35861 13.7754C8.11454 14.0195 7.71881 14.0195 7.47473 13.7754C7.23065 13.5314 7.23065 13.1356 7.47473 12.8916L10.3661 10.0002L7.47473 7.10877C7.23065 6.86469 7.23065 6.46896 7.47473 6.22489Z"
                      fill="#04D9FF"
                    />
                  </svg>
                </span>
                <div className="ShowChallengePopup">
                  {showCalender && <TableCalender />}
                </div> */}
                </th>
                <th>Amount</th>
                {/* <th>Invoice</th> */}
                <th>Status</th>
                <th>Attachment</th>
              </tr>
            </thead>
            {/* <tbody>{Data.map(renderLeaderBoard)}</tbody> */}
            <tbody>
              {Object.keys(DataInfo).map((data, key) => {
                return (
                  <tr
                    key={key}
                    style={{
                      background: "#010101",
                      backgroundColor: "#010101",
                    }}
                  >
                    <td>
                      {userNameFormatter(DataInfo[data].Funding_evaluation)}
                    </td>
                    <td>
                      {DataInfo[data].Account_balance
                        ? dollarUS(Number(DataInfo[data].Account_balance))
                        : false}
                    </td>
                    <td className="paymentTD">{DataInfo[data].payment_id}</td>
                    <td>
                      {DataInfo[data].date
                        ? formatDate(new Date(DataInfo[data].date))
                        : false}
                    </td>
                    <td>
                      {DataInfo[data].amount
                        ? dollarUS(Number(DataInfo[data].amount) / 100)
                        : false}
                    </td>
                    {/* <td>
                      <a href={DataInfo[data].invoice}>
                        <img src={invoice} style={{ filter: "invert(1)" }} />
                      </a>
                    </td> */}
                    <td>{StatFormatter(DataInfo[data].payment_status)}</td>
                    <td>
                      {DataInfo[data].invoice &&
                        DataInfo[data].invoice !== "Not Created" && (
                          <a
                            href={DataInfo[data].invoice}
                            target="_blank"
                            rel="noreferrer"
                            style={{ color: "#04d9ff" }}
                          >
                            Invoice
                            <img src={invoice} alt="" style={{marginLeft:"10px"}}/>
                          </a>
                        )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </ReactBootstrap.Table>
        </div>
      ) : (
        false
      )}

      {isMobile ? (
        <div className="Historymobile">
          {Object.keys(DataInfo).map((data, key) => {
            return (
              <div className="Box mbb-10" key={key}>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gapp-10">
                    <Title four>
                      {userNameFormatter(DataInfo[data].Funding_evaluation)}
                    </Title>
                    <div className="Date">
                      {DataInfo[data].date
                        ? formatDate(new Date(DataInfo[data].date))
                        : false}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      gap: "1rem",
                    }}
                  >
                    {DataInfo[data].invoice &&
                      DataInfo[data].invoice !== "Not Created" && (
                        <a
                          href={DataInfo[data].invoice}
                          target="_blank"
                          rel="noreferrer"
                          className="download-button"
                        >
                          <img style={{padding:"10px"}} src={invoice} alt="" />
                        </a>
                      )}
                    {StatFormatter(DataInfo[data].payment_status)}
                  </div>
                </div>
                <div className="d-flex justify-content-between mtt-20 BoxS">
                  <HeadAndDesc
                    HeadTitle="Account Balance"
                    SubTitle={
                      DataInfo[data].Account_balance
                        ? dollarUS(Number(DataInfo[data].Account_balance))
                        : false
                    }
                  />
                  <HeadAndDesc
                    SubTitleClass="paymentTD"
                    HeadTitle="Transaction ID"
                    SubTitle={DataInfo[data].payment_id}
                  />
                  <HeadAndDesc
                    HeadTitle="Amount"
                    SubTitle={
                      DataInfo[data].amount
                        ? dollarUS(Number(DataInfo[data].amount) / 100)
                        : false
                    }
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        false
      )}
    </div>
  );
};
export default PaymentHistory;
